export default {
  // API_ENDPOINT: 'http://localhost:8000/api'
  API_ENDPOINT: 'https://dry-ocean-59677.herokuapp.com/api'
};